import React from 'react'
import { observer } from "mobx-react-lite"
import { useStore } from '../../../../../../hooks/useStore'
import { PillButton } from '../../../../../general/buttons/pill-button';
import { getContentfulImageURL, preloadImage } from '../../../../../../utils/general';


const OrgListUI = observer((props) => {
    const {uiStore: {home__share__activeCity}} = useStore();
    if (!home__share__activeCity) return null
    
    return <ActiveOrgList {...props}/>

});

const ActiveOrgList = observer((props) => {
    const {uiStore: {home__share__activeCity, home__share__activeOrg, showShareCard}} = useStore();
    let data;
    
    switch(home__share__activeCity) {
        case "Atlanta":
            data = props.locationData.orgsAtlanta.edges;
            break
        case "Philadelphia":
            data = props.locationData.orgsPhiladelphia.edges;
            break;
        case "Chicago":
            data = props.locationData.orgsChicago.edges;
            break;
        case "Detroit":
            data = props.locationData.orgsDetroit.edges;
            break;
        case "LA":
            data = props.locationData.orgsLA.edges;
            break;
        case "Buffalo":
            data = props.locationData.orgsBuffalo.edges;
            break;
        default:
            data = [];
    }

    return (
        <div>
            <div className='flex--center'>
                <OrganizationList data={data}/>
            </div>

            <div className='btn-section flex--center'>
                <PillButton onClick={showShareCard} isDisabled={!!!home__share__activeOrg}>Select this nonprofit</PillButton>
            </div>

            <style jsx>{`
                .btn-section {
                    margin-top: 12px;
                    padding: 20px;
                }
            `}</style>
        </div>
    )
});

const OrganizationList = observer(({data}) => {
    const {uiStore: {home__share__activeOrg}} = useStore();


    return(
        <div className="org-list">
            {data.map(org => {
                return <OrganizationButton key={`org-sh-${org.node.name}`} data={org.node} isActive={home__share__activeOrg?.name === org.node.name}/>
            })}

            <style jsx global>{`
                .org-list {
                    height: 400px;
                    overflow-y: scroll;
                }

                .org-list::-webkit-scrollbar {
                    width: 10px; /* Mostly for vertical scrollbars */
                    height: 10px; /* Mostly for horizontal scrollbars */
                  }
                .org-list::-webkit-scrollbar-thumb { /* Foreground */
                    background: #bbb;
                    border-radius: 10px;
                  }
                .org-list::-webkit-scrollbar-track { /* Background */
                    background: #fff;
                    border-radius: 10px;
                  }
                

                @media (max-width: 768px), (pointer: coarse) {
                    .org-list {
                        height: 300px;
                        width: 100%;
                    }
                }

            `}</style>
        </div>
    )
})

const OrganizationButton = React.memo(({data, isActive}) => {
    const {uiStore: {updateActiveShareOrg}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();
    return (
        <div 
            className={isActive ? "active" : ""}
            onClick={() => {
                updateActiveShareOrg(data)
                if (data.shareCardImage) {
                    preloadImage(getContentfulImageURL(data.shareCardImage?.file.url, 1400, 90))
                }
            }}
            onMouseLeave={() => {
                handleMouseLeave()
            }}
            onMouseEnter={() => {
                handleMouseEnter("action");
            }}
        >

            <h4 className='text-m'>{data.name}</h4>


            <style jsx>{`
                div {
                    padding: 12px;
                }
                .active h4{
                    background: #bbb;
                }

                h4 {
                    padding: 6px;
                    text-align: center;
                    width: 90%;
                    margin: 0 auto;
                    border-radius: 100px;
                    transition: background 0.2s ease;
                }
            `}</style>
        </div>
    )
})

export default OrgListUI